<template>
<div>
    <collection-search @search-collection="searchCollection" />
    <div
        :class="{
			'flex flex-wrap transition duration-300': true,
			'opacity-50 pointer-events-none': loading,
			'opacity-100': !loading
		}"
    >
        <article
            v-if="entry.title"
            v-for="entry in entries"
            :key="entry.id"
            class="w-full md:w-1/3"
        >
            <div class="mx-4 my-2 bg-[#F5F8FB] rounded min-h-[525px] flex flex-col overflow-hidden hover:shadow-2xl transition ease-in-out">
                <a
                    :href="entry.uri"
                    :aria-label="entry.title"
                    class="article-image relative h-[240px]"
                >
                    <div class="overlay absolute w-full h-full z-5" />
                    <img
                        v-if="entry.main_image"
                        :src="getGlideImage(entry.main_image, 368, 240)"
                        :alt="entry.title"
                        width="368"
                        height="240"
                        loading="lazy"
                        class="absolute w-full h-full top-0 left-0 object-cover object-center z-1"
                    >
                </a>
                <div class="my-4 mx-8 flex-auto flex flex-col justify-between">
                    <div>
                        <span class="text-[#E4097E] font-semibold text-xs uppercase">
                            {{ entry.date | formatDate }}
                        </span>
                        <div class="text-[#E4097E] font-semibold text-xs uppercase">
                            <a
                                v-for="(taxonomy, index) in entry.business_advice_tags"
                                :key="index"
                                :href="`/start-up-advice/${taxonomy.slug}`"
                                class="hover:underline"
                            >
                                {{ taxonomy.title }}<span v-if="entry.business_advice_tags && entry.business_advice_tags.length > (index + 1)">,</span>
                            </a>
                        </div>
                        <h2 class="text-[#OF2136] my-2 font-semibold text-lg tracking-wide line-clamp-2">
                            {{ entry.title }}
                        </h2>
                        <p class="text-[#6B7C94] my-2 line-clamp-4">{{ entry.short_description }}</p>
                    </div>
                    <a
                        :href="entry.uri"
                        class="text-[#E4097E] font-semibold text-sm cursor-pointer hover:text-[#OF2136]"
                    >
                        Read More
                        <fa-icon :icon="['fas', 'fa-angle-right']" fixed-width/>
                    </a>
                </div>
            </div>
        </article>
        <div class="w-full">
            <div class="mx-auto w-max" v-if="nextPage">
                <button
                    class="font-semibold bg-[#F5F8FB] my-4 py-2 px-6 rounded"
                    type="button"
                    @click.prevent="getEntries(null, false)"
                >
                    LOAD MORE
                </button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import {cloneDeep} from 'lodash';
import { debounce } from 'lodash';
import axios from 'axios';
import ShowsGlideImage from '../mixins/ShowsGlideImage';

export default {
    name: 'BusinessAdviceBlock',

    mixins: [
        ShowsGlideImage
    ],

    props:['filter'],

    data () {
        return {
            loading: false,
            error: null,
            entries: [],
            filters: null,
            search: null,
            meta: null
        }
    },

    computed: {
        nextPage () {
            return this.meta?.next_page || null
        }
    },

    mounted () {
        if (this.filter) {
            this.filters = {
                'business_advice_tags|tax_in': [this.filter]
            }
        }
        this.getEntries()
    },

    created () {
        this.getEntries = debounce(this.getEntries, 500)
    },

    methods: {
        searchCollection (event) {
            this.loading = true;
            this.search = event;
            this.getEntries();
        },

        getEntries ($event = null, fresh = true) {
            this.loading = true

            if (fresh) {
                this.meta = {
                    next_page: null,
                    current_page: 1,
                    last_page: null
                }
            }

            const url = this.meta && this.meta.next_page ? this.meta.next_page : '/api/business_advice'

            axios.get(url, {
                params: {
                    order: this.order,
                    limit: 12,
                    filter: this.filters,
                    search: this.search
                }
            })
            .then((res) => {
                this.entries = fresh ? res.data.data : [
                    ...cloneDeep(this.entries),
                    ...Object.values(res.data.data)
                ]
                this.meta = {
                    next_page: res.data.next_page_url,
                    current_page: res.data.current_page,
                    last_page: res.data.last_page
                }
            })
            .catch((err) => {
                this.error = 'Unable to fetch entries at this time.'
            })
            .finally(() => {
                this.loading = false
            })
        }
    }
}
</script>
